// Auto-generated from .telemetry/tracking-plan.yaml v1
// Regenerate with: product-tracking-implement-tracking skill
// DO NOT use raw string event names anywhere in the codebase — always import from here

export const Events = {
  // Lifecycle
  LOGIN: 'login',
  USER_INVITED: 'user_invited',
  USER_ADDED: 'user_added',

  // Core Value — Insights
  INSIGHT_VIEWED: 'insight_viewed',
  LABEL_SELECTED: 'label_selected',
  DATE_RANGE_SELECTED: 'date_range_selected',
  INSIGHT_SEARCHED: 'insight_searched',
  INSIGHT_DRAWER_OPENED: 'insight_drawer_opened',
  GALLERY_VIEWED: 'gallery_viewed',
  INSIGHTS_EXPORTED: 'insights_exported',

  // Core Value — Ad Summary
  AD_SUMMARY_VIEWED: 'ad_summary_viewed',
  VIEW_SWITCHED: 'view_switched',

  // Configuration
  KPI_CHANGED: 'kpi_changed',
  BRAND_CONNECTED: 'brand_connected',

  // Ad Management
  AD_APPROVED: 'ad_approved',
  AD_DUPLICATED: 'ad_duplicated',
  AD_DELETED: 'ad_deleted',
  AD_DRAFT_CREATED: 'ad_draft_created',

  // Collaboration
  COMMENT_ADDED: 'comment_added',
} as const

export type EventName = typeof Events[keyof typeof Events]

// Sent to Mixpanel directly (not through Segment). Names match the product spec verbatim.
export const MixpanelEvents = {
  SHARE_INSIGHT: 'Share insight',
  DOWNLOAD_PNG: 'Download PNG',
  COPY_IMAGE: 'Copy image',
} as const

export type MixpanelEventName = typeof MixpanelEvents[keyof typeof MixpanelEvents]
